var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanySize1150(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.746,
    height: 49.799,
    viewBox: "0 0 73.746 49.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "company_size_11-50_clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2635",
    "data-name": "Rectangle 2635",
    width: 73.746,
    height: 49.799,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3334",
    "data-name": "Group 3334",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1580",
    "data-name": "Group 1580",
    transform: "translate(0 0)",
    clipPath: "url(#company_size_11-50_clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M72.75,575.642H1a1,1,0,1,0,0,1.993H72.75a1,1,0,1,0,0-1.993",
    transform: "translate(0 -527.836)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M107.782,76.5a1,1,0,0,0-1,1v41.447a1,1,0,0,0,1,1h48.366a1,1,0,0,0,1-1V76.5Zm47.37,20.719v20.728H108.778V78.493h46.373V97.219Z",
    transform: "translate(-97.917 -70.147)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M612.949,0h-7a1,1,0,0,0-1,1V7.31a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V1a1,1,0,0,0-1-1m-1,6.313h-5V1.993h5Z",
    transform: "translate(-554.717)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M174.562,383.464a5.718,5.718,0,0,0-5.712,5.712v10.885a1,1,0,0,0,1,1h9.43a1,1,0,0,0,1-1V389.176a5.718,5.718,0,0,0-5.712-5.712m3.718,15.6h-7.437v-9.889a3.718,3.718,0,1,1,7.437,0Z",
    transform: "translate(-154.827 -351.618)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M207.811,155.01H168.989a1,1,0,0,0-1,1v10.671a1,1,0,0,0,1,1h38.823a1,1,0,0,0,1-1V156.007a1,1,0,0,0-1-1m-1,10.671h-36.83V157h36.83Z",
    transform: "translate(-154.041 -142.137)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M386.871,362.009H364.99a1,1,0,0,0-1,1v10.48a1,1,0,0,0,1,1h21.881a1,1,0,0,0,1-1v-10.48a1,1,0,0,0-1-1m-1,10.48H365.986V364h19.888Z",
    transform: "translate(-333.764 -331.945)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2632",
    "data-name": "Rectangle 2632",
    width: 1.993,
    height: 10.835,
    transform: "translate(26.899 13.721)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2633",
    "data-name": "Rectangle 2633",
    width: 1.993,
    height: 10.835,
    transform: "translate(39.826 13.721)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2634",
    "data-name": "Rectangle 2634",
    width: 1.993,
    height: 10.835,
    transform: "translate(41.169 30.883)",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanySize1150);
export default __webpack_public_path__ + "static/media/company_size_11-50.729c3454.svg";
export { ForwardRef as ReactComponent };